import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
  }

  submit(event) {
    if (!document.getElementById('link-search')) {
      document.getElementById('portfolio-tabs')?.insertAdjacentHTML('afterbegin', `<li id="link-search" class="nav-item"> <a class="nav-link" data-bs-toggle="tab" href="#tab-search">Search Results</a></li>`);
      bootstrap.Tab.getOrCreateInstance(document.querySelector('a[href="#tab-search"]')).show();
      const tabSearch = document.getElementById('tab-search');
      if (tabSearch) tabSearch.innerHTML = "<p class='empty'>Loading ...</p>";
    }
    bootstrap.Tab.getOrCreateInstance(document.querySelector('a[href="#tab-search"]')).show();
  }
}
